<div
  id="default-page"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start">
  <div id="default-page-intro" fxFlex fxHide fxShow.gt-sm>
    <div
      class="title"
      [@animate]="{ value: '*', params: { delay: '50ms', y: '25px' } }">
      {{ 'GENERAL.TITLE.SITE' | translate }}
    </div>
  </div>
  <div
    id="default-page-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }">
    <div id="default-page-form">
      <div class="title">{{ 'RECOVERY.SUBTITLE' | translate }}</div>
      <form name="forgoPasswordForm" [formGroup]="forgotPasswordForm">
        <mat-form-field appearance="outline">
          <mat-label>{{
            'USERS.SINGLE.INFO.RECOVERYEMAIL' | translate
          }}</mat-label>
          <input matInput formControlName="email" autoComplete="on" />
          <mat-icon matSuffix class="secondary-text">mail</mat-icon>
          @if (forgotPasswordForm.get('email').invalid) {
            <mat-error>
              {{ 'ERROR.EMAIL_VALID' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <button
          mat-raised-button
          class="submit-button"
          color="accent"
          (click)="sendResetLink()"
          aria-label="SEND RESET LINK"
          [disabled]="
            forgotPasswordForm.invalid ||
            (forgotPasswordForm.pristine && forgotPasswordForm.untouched)
          ">
          {{ 'RECOVERY.SENDBTN' | translate }}
        </button>
        @if (isBusy) {
          <div fxLayout="row" fxLayoutAlign="center center">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
        }
        @if (ErrorRecoveryEmail) {
          <div>
            <div class="message-box error">
              <app-error-message [error]="error.error" />
            </div>
          </div>
        }
        @if (isEmailSend) {
          <div>
            <div class="message-box success">
              {{ 'RECOVERY.CONFIRMATION' | translate }}
            </div>
          </div>
        }
      </form>
      <div class="login" fxLayout="row" fxLayoutAlign="center center">
        <a class="link" [routerLink]="'/login'">
          {{ 'RECOVERY.BACK' | translate }}</a
        >
      </div>
    </div>
  </div>
</div>
